export default __webpack_public_path__ + "static/media/3.73aa11fd.png";